export default class Captcha {
  token: string | null = null
  question: String | null = null
  result: String | null = null
}
